<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      :resource="resource"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class OrderDetail extends Vue {
  data = {}
  @Prop(String) resource;

  get columns() {
    return createColumns.call(this, {
      actionColumn: {
        detail: false
      },
      resource: this.resource
    });
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.data = await this.$request.get(`${this.resource}/${this.$route.params.id}`);
  }
}
</script>
